import { render, staticRenderFns } from "./ManagerOrderCard.vue?vue&type=template&id=3dc7b1bd&scoped=true&"
import script from "./ManagerOrderCard.vue?vue&type=script&lang=js&"
export * from "./ManagerOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./ManagerOrderCard.vue?vue&type=style&index=0&id=3dc7b1bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7b1bd",
  null
  
)

export default component.exports